import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Facebook, Instagram, Linkedin } from 'lucide-react';
import { useLang } from '../context/LanguageContext';
import { COMPANY, LOGO_URL } from '../mock';

const Footer = () => {
  const { t } = useLang();
  const year = new Date().getFullYear();

  return (
    <footer className="bg-slate-950 text-slate-300">
      <div className="max-w-7xl mx-auto px-5 md:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div className="md:col-span-2">
            <div className="inline-flex bg-white rounded-xl px-4 py-2.5 shadow-sm">
              <img
                src={LOGO_URL}
                alt="VenaTerra — Blood of Logistics"
                className="h-14 w-auto object-contain"
                loading="lazy"
              />
            </div>
            <p className="mt-5 text-[14.5px] leading-relaxed text-slate-400 max-w-md">
              {t.footer.about}
            </p>
            <div className="flex items-center gap-3 mt-6">
              <a href={COMPANY.socials.facebook} target="_blank" rel="noreferrer" aria-label="Facebook" className="w-9 h-9 rounded-full border border-white/10 flex items-center justify-center text-slate-400 hover:text-white hover:border-slate-600 transition-colors"><Facebook size={16} /></a>
              <a href={COMPANY.socials.instagram} target="_blank" rel="noreferrer" aria-label="Instagram" className="w-9 h-9 rounded-full border border-white/10 flex items-center justify-center text-slate-400 hover:text-white hover:border-slate-600 transition-colors"><Instagram size={16} /></a>
              <a href={COMPANY.socials.linkedin} target="_blank" rel="noreferrer" aria-label="LinkedIn" className="w-9 h-9 rounded-full border border-white/10 flex items-center justify-center text-slate-400 hover:text-white hover:border-slate-600 transition-colors"><Linkedin size={16} /></a>
            </div>
          </div>

          <div>
            <div className="text-[12px] uppercase tracking-[0.16em] text-slate-500 mb-4">{t.footer.quickLinks}</div>
            <ul className="space-y-2.5 text-[14.5px]">
              <li><Link to="/" className="hover:text-white transition-colors">{t.nav.home}</Link></li>
              <li><Link to="/services" className="hover:text-white transition-colors">{t.nav.services}</Link></li>
              <li><Link to="/fleet" className="hover:text-white transition-colors">{t.nav.fleet}</Link></li>
              <li><Link to="/about" className="hover:text-white transition-colors">{t.nav.about}</Link></li>
              <li><Link to="/contact" className="hover:text-white transition-colors">{t.nav.contact}</Link></li>
            </ul>
          </div>

          <div>
            <div className="text-[12px] uppercase tracking-[0.16em] text-slate-500 mb-4">{t.footer.legal}</div>
            <ul className="space-y-2.5 text-[14.5px] text-slate-400">
              <li className="flex items-start gap-2.5"><MapPin size={16} className="mt-0.5 shrink-0" /><span>{COMPANY.address}</span></li>
              <li className="flex items-start gap-2.5"><Mail size={16} className="mt-0.5 shrink-0" /><a href={`mailto:${COMPANY.email}`} className="hover:text-white transition-colors">{COMPANY.email}</a></li>
              <li className="flex items-start gap-2.5"><Phone size={16} className="mt-0.5 shrink-0" /><span>{COMPANY.phone}</span></li>
              <li className="pt-2 text-[13px] text-slate-500">IČO: {COMPANY.ico} · DIČ: {COMPANY.dic}</li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/10/80 flex flex-col md:flex-row items-center justify-between gap-3 text-[13px] text-slate-500">
          <div>© {year} {COMPANY.name}. {t.footer.rights}</div>
          <div className="flex items-center gap-5">
            <a href="#" className="hover:text-white transition-colors">{t.footer.privacy}</a>
            <a href="#" className="hover:text-white transition-colors">{t.footer.terms}</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
